module.exports = __webpack_public_path__ + "img/btn_bottom_c.a7f80848.png";